import Model from '../Model'
import moment from "moment/moment";

export default class ToolboxTalk extends Model {

    getDownloadUrl() {
        return route('api.v2.hsqe.toolbox-talks.pdf', [this.packageReference, this.id])
    }

    getPrintableUrl() {
        return route('api.v2.hsqe.toolbox-talks.download', [this.packageReference, this.id])
    }

    async send(attributes = {}) {
        const url = route('api.v2.hsqe.toolbox-talks.send', [this.packageReference, this.id])
        let success
        try {
            success = await Http.post(url, attributes)
        } catch (error) {
            return error.response
        }
        const data = await Http.get(route('api.v2.hsqe.toolbox-talks', [this.packageReference, this.id]))
        Object.assign(this,data)
        return success;
    }

    async revoke(sendRequestId) {
        const url = route('api.v2.hsqe.toolbox-talks.revoke', [this.packageReference, this.id, sendRequestId])
        let success
        try {
            success = await Http.post(url, {})
        } catch (error) {
            return error.response
        }
        const data = await Http.get(route('api.v2.hsqe.toolbox-talks', [this.packageReference, this.id]))
        Object.assign(this, data)
        return success;
    }

    async resend(sendRequestId) {
        const url = route('api.v2.hsqe.toolbox-talks.resend', [this.packageReference, this.id, sendRequestId])
        let success
        try {
            success = await Http.post(url, {})
        } catch (error) {
            return error.response
        }
        const data = await Http.get(route('api.v2.hsqe.toolbox-talks', [this.packageReference, this.id]))
        Object.assign(this, data)
        return success;
    }

    async reload() {
        let o = await ToolboxTalk.find(this.packageReference, this.id)
        Object.assign(this, o)
    }

    setAttributes(attributes) {
        super.setAttributes(attributes)
        this.formattedDate = moment(attributes.date).format('DD/MM/YYYY');
        let tokens = [
            this.givenByName,
            this.formattedDate,
        ]
        this.tokens = tokens.join('|').toLowerCase();
        if (this.attendees) {
            this.attendees.sort((a, b) => a.order - b.order)
        }
        if (this.externalInvites) {
            this.externalInvites.forEach((i) => {
                i.invitedAt = moment(i.createdOn).format('DD/MM/YYYY HH:mm:ss');
            })
            this.externalInvites.sort((a, b) => moment(b.createdOn).valueOf() - moment(a.createdOn).valueOf())
        }
    }

    static async find(packageReference, id) {
        const data = await Http.get(route('api.v2.hsqe.toolbox-talks', [packageReference, id]))
        return this.make(data);
    }

    static async all(packageReference = null) {
        const params = {}
        const data = await Http.get(route('api.v2.hsqe.toolbox-talks.list', [packageReference]), {params})
        return this.make(data)
    }

    static async create(packageReference, id, attributes = {}) {
        const success = await Http.post(route('api.v2.hsqe.toolbox-talks.create', [packageReference, id]), attributes);
        const data = await Http.get(route('api.v2.hsqe.toolbox-talks', [packageReference, id]))
        return this.make(data)
    }

    async update(attributes = {}) {
        const url = route('api.v2.hsqe.toolbox-talks.store', [this.packageReference, this.id])
        const payload = this.constructor.parseAttributes({...this.getFormAttributes(), ...attributes})
        const success = await Http.put(url, payload)
        const data = await Http.get(route('api.v2.hsqe.toolbox-talks', [this.packageReference, this.id]))
        return this.fill(data)
    }

    async requestSignature(attendeeId, to) {
        const url = route('api.v2.hsqe.toolbox-talks.request-signature', [this.packageReference, this.id])
        const success = await Http.put(url, {attendeeId, to})
        const data = await Http.get(route('api.v2.hsqe.toolbox-talks', [this.packageReference, this.id]))
        return this.fill(data)
    }

    async delete() {
        await Http.delete(route('api.v2.hsqe.toolbox-talks.delete', [this.packageReference, this.id]))
    }
}
